import React, {useEffect, useState} from 'react'

import clpLogo from "../../resources/ClassplusLogo.png";
import html2canvas from "html2canvas";
import download from "../../resources/Download.png";

import createNow from "../../resources/createNew.png";
import memory from "../../resources/creatememorynow.png";


import "./withCreativeUrl.css";
import { withRouter } from 'react-router';

const WithCreativeURLPage = (props) => {


    const handleCreateNow = () => {
        props.history.push({
            pathname: '/welcomePage', 
            
          })
    }


    const downloadImage = () => {

            (async () => {
    
                let a = document.createElement('a');
    
                let response = await fetch(creativeUrl);
                console.log(response)
    
    
                let file = await response.blob();
    
                a.download = 'classWaliDosti';
                a.href = window.URL.createObjectURL(file);
    
                a.dataset.downloadurl = ['application/octet-stream', a.download, a.href].join(':');
    
                a.click();
            })();
        
    }


    const [creativeUrl, setcreativeUrl] = useState()

    useEffect(() => {
        setcreativeUrl(sessionStorage.getItem("creativeUrl"))
    }, [])

    return (
        <div id="creativeUrl-page">
        <div id="navbar">
          <img src={clpLogo} id="navbar-clpLogo" />
        </div>

        <div id="creativeUrl-heading">Ek special #ClassWaliDosti ki memory</div>

        <div id="card-display">
                <img id="card-display-img" crossOrigin="anonymous" src={creativeUrl} />
        </div>

        <div id="creativeUrl-middle">Yaad hai jb hum class mae yeh kiya krte the. Meri tarah, tum bhi apni khud ki #ClassWaliDosti post bana skte ho.</div>


        <div id="creativeUrl-bottom">
        <img src={memory} id="creativeurl-memory"/>
          <div id="creativeUrl-cta-block">  
            <img src={download} onClick={()=>{downloadImage()}} />
            <img src={createNow} onClick={()=>{handleCreateNow()}} />
            </div>
        </div>
        </div>
    )
}

export default withRouter(WithCreativeURLPage);
